import { useEffect, useState, useMemo } from 'react';
import { useApolloClient, useMutation, useLazyQuery } from '@apollo/client';
import { GET_NOTIFICATION } from '../../graph_ql/communication/notification/queries';
import { MARK_READ_WITH_ID } from '../../graph_ql/communication/notification/mutations';
import classes from './notification.module.scss';
import { authenticationActions, selectApproved } from 'redux/authentication/authentication.slice';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationVerb } from '../../constants';
import { useAuth } from '../../contexts/AuthContext';
import { useHistory } from 'react-router-dom';
import { PATH } from 'routes/constant';
import { GET_ORDER_DETAIL } from 'graph_ql/order/queries';
import { database } from '../../firebase';
import { GET_SESSION_DETAIL } from 'graph_ql/styling_session/queries';
export const NotificationPerTime = () => {
    let history = useHistory();
    const location = useLocation();
    const { currentUser } = useAuth();
    const [show, setShow] = useState(false);
    const client = useApolloClient();
    const [mutateFunction] = useMutation(MARK_READ_WITH_ID);
    const [latestNotification, setLatestNotification] = useState(null);
    const [orderTaffiId, setOrderTaffiId] = useState('');
    const [sessionTaffiId, setSessionTaffiId] = useState('');
    const [getOrderDetail, { data: orderData }] = useLazyQuery(GET_ORDER_DETAIL, {
        onCompleted(response) {
            if (response.myOrder?.data?.length) {
                setOrderTaffiId(response.myOrder.data[0].taffiId);
            }
        },
    });

    const [getSessionDetail, { data: sessionDetails }] = useLazyQuery(GET_SESSION_DETAIL, {
        onCompleted(response) {
            if (response?.getSessionDetails?.taffiId) {
                setSessionTaffiId(response.getSessionDetails?.taffiId);
            }
        },
    });

    useEffect(() => {
        if (orderTaffiId) history.push(`${PATH.ODER_DETAIL}/${orderTaffiId}`);
        return () => {
            setOrderTaffiId('');
        };
    }, [orderTaffiId, history]);

    useEffect(() => {
        if (sessionTaffiId) history.push(`${PATH.STYLE_REQUEST}/${sessionTaffiId}`);
        return () => {
            setOrderTaffiId('');
        };
    }, [sessionTaffiId, history]);

    const dispatch = useDispatch();
    const checkApproved = useSelector(selectApproved);
    const runQuery = useMemo(
        () => async () => {
            const { data: notificationData } = await client.query({
                query: GET_NOTIFICATION,
                variables: {
                    paging: {
                        size: 10,
                        page: 0,
                    },
                },
                fetchPolicy: 'network-only',
                context: {
                    headers: {
                        background: 1,
                    },
                    clientName: 'notification',
                },
            });
            setLatestNotification(notificationData?.getNotification?.data[0]);
            return notificationData?.getNotification?.data[0];
        },
        [client],
    );

    useEffect(() => {
        if (currentUser?.uid && location.pathname !== PATH.PDP_WIDGET) {
            const onValueChange = database.realtimeDatabase
                .ref('notifications')
                .child(currentUser?.uid)
                .child('lastUpdated')
                .on('value', async (snapshot) => {
                    console.log('notifications snapshot', snapshot, currentUser?.uid);
                    await runQuery()
                        .then((latestNotification) => {
                            const mostRecentNotificationId = localStorage.getItem('mostRecentNotificationId');
                            const notificationStartTime = localStorage.getItem('startTime');

                            if (
                                latestNotification &&
                                Date.parse(latestNotification.created) > Number(notificationStartTime) &&
                                mostRecentNotificationId !== latestNotification.id
                            ) {
                                localStorage.setItem('mostRecentNotificationId', latestNotification.id);
                                setShow(true);
                            }
                        })
                        .catch(() => {
                            console.debug('GET_NOTIFICATION failed.');
                        });
                });
            return () => {
                database.realtimeDatabase
                    .ref('notifications')
                    .child(currentUser?.uid)
                    .child('lastUpdated')
                    .off('value', onValueChange);
            };
        }
    }, [currentUser?.uid, location.pathname, runQuery]);

    useEffect(() => {
        const markReadAndReload = async (latestNotification) => {
            await mutateFunction({
                variables: {
                    input: {
                        id: latestNotification.id,
                    },
                },
            });
            await client.refetchQueries({
                include: [GET_NOTIFICATION],
            });
        };
        if (show) {
            if (latestNotification && latestNotification.verb === NotificationVerb.UserStylistApproved) {
                dispatch(authenticationActions.setApproved(true));
                markReadAndReload(latestNotification);
                if (checkApproved) history.push(PATH.HOME);
            }
        }
        const timer = setTimeout(() => {
            show && setShow(false);
        }, 3000);
        return () => {
            clearTimeout(timer);
        };
    }, [show, checkApproved, dispatch, history, latestNotification, mutateFunction, client]);

    const refreshNotification = useMemo(
        () => async (latestNotification) => {
            await mutateFunction({
                variables: {
                    input: {
                        id: latestNotification.id,
                    },
                },
            });
            await client.refetchQueries({
                include: [GET_NOTIFICATION],
            });
        },
        [client, mutateFunction],
    );
    const handleClick = useMemo(
        () => (latestNotification) => {
            location.pathname === PATH.NOTIFICATIONS ? runQuery() : refreshNotification(latestNotification);
            setShow(false);
        },
        [location.pathname, refreshNotification, runQuery],
    );

    const handleNotificationVerb = useMemo(
        () => async (item) => {
            switch (item.verb) {
            case NotificationVerb.OrderPaymentSuccess:
            case NotificationVerb.OrderUpdate:
            case NotificationVerb.OrderShipped:
            case NotificationVerb.OrderDelivered:
                await getOrderDetail({
                    variables: {
                        input: {
                            id: item.targetObjectId,
                            paging: {
                                page: 0,
                                size: 10,
                            },
                        },
                    },
                });
                if (orderData && orderData.myOrder.data.length) history.push(`${PATH.ODER_DETAIL}/${orderTaffiId}`);
                break;

            case NotificationVerb.StyleGuideReady:
                history.push(PATH.STYLE_GUIDE);
                break;
            case NotificationVerb.SessionScheduled:
            case NotificationVerb.SessionCancelled:
            case NotificationVerb.SessionRescheduled:
                await getSessionDetail({
                    variables: {
                        input: {
                            id: item?.targetObjectId,
                        },
                    },
                });
                if (sessionDetails && sessionDetails?.taffiId)
                    history.push(`${PATH.STYLE_REQUEST}/${sessionTaffiId}`);
                break;
            case NotificationVerb.StylistAddedOutcome:
                if (item?.targetObjectId) history.push(`${PATH.STYLE_REQUEST}/${item?.targetObjectId}`);
                break;
            case NotificationVerb.CustomerReacted:
                if (item?.targetObjectId) history.push(`${PATH.STYLE_DETAIL}/${item?.targetObjectId}`);
                break;
            case NotificationVerb.CustomerViewedStyle:
                if (item?.targetObjectId) history.push(`${PATH.STYLE_DETAIL}/${item?.targetObjectId}`);
                break;
            default:
                history.push(PATH.NOTIFICATIONS);
            }
        },
        [getOrderDetail, history, orderData, orderTaffiId, getSessionDetail, sessionDetails, sessionTaffiId],
    );

    return (
        <>
            {show && (
                <>
                    <div className={classes['notification']}>
                        <div
                            onClick={() => {
                                handleNotificationVerb(latestNotification);
                                handleClick(latestNotification);
                            }}
                        >
                            <div className={classes['notification-item']}>
                                <div className={classes['notification-image']}>Taffi</div>
                                <p>{latestNotification?.message}</p>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};
// NotificationPerTime.whyDidYouRender = true;
export default NotificationPerTime;
